import { render, staticRenderFns } from "./LiberayManagement.vue?vue&type=template&id=64719a88&scoped=true"
import script from "./LiberayManagement.vue?vue&type=script&lang=js"
export * from "./LiberayManagement.vue?vue&type=script&lang=js"
import style0 from "./LiberayManagement.vue?vue&type=style&index=0&id=64719a88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64719a88",
  null
  
)

export default component.exports